import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/transactions/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello &quot;/transactions/$id&quot;!</div>;
}
